import {Component} from '@angular/core';
import {PageEvent} from '@angular/material';
/**
 * \@title Configurable paginator
 */
export class PaginatorConfigurableExample {
  // MdPaginator Inputs
  length = 100;
  pageSize = 10;
  pageSizeOptions = [5, 10, 25, 100];

  // MdPaginator Output
  pageEvent: PageEvent;
/**
 * @param {?} setPageSizeOptionsInput
 * @return {?}
 */
setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'paginator-configurable-example',
  templateUrl: 'paginator-configurable-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PaginatorConfigurableExample_tsickle_Closure_declarations() {
/** @type {?} */
PaginatorConfigurableExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PaginatorConfigurableExample.ctorParameters;
/** @type {?} */
PaginatorConfigurableExample.prototype.length;
/** @type {?} */
PaginatorConfigurableExample.prototype.pageSize;
/** @type {?} */
PaginatorConfigurableExample.prototype.pageSizeOptions;
/** @type {?} */
PaginatorConfigurableExample.prototype.pageEvent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
